import { Box, Divider, Typography } from '@mui/material';
import React from 'react';

import { DataRequestItem } from '../../../Types/dealGPT';
import { EventSource, HistoryViewMode } from '../../../Types/enums';
import EventHistory from '../EventHistory';

export interface DataRequestListItemHistoryProps {
  item: DataRequestItem;
}

const DataRequestListItemHistory: React.FC<DataRequestListItemHistoryProps> = ({ item }) => {
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Box position="sticky" top={0} zIndex={1} bgcolor="white" pb={1}>
        <Typography variant="h5" mb={1}>
          History
        </Typography>
        <Divider />
      </Box>
      <EventHistory
        entityType={EventSource.DATA_REQUEST_ITEM}
        entityId={item.id}
        viewMode={HistoryViewMode.DETAILED}
      />
    </Box>
  );
};

export default DataRequestListItemHistory;
